async function getCocktails() {
    const url = "https://cocktails.solvro.pl/api/v1/cocktails/";
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error(error);
    }
}
async function getCocktail(cocktailId) {
    const url = `https://cocktails.solvro.pl/api/v1/cocktails/${cocktailId}`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error(error);
    }
}

export { getCocktails, getCocktail };